import { useEffect, useState } from "react";
import { getIncomeExpense } from "../api/reports";
import type { IncomeExpenseReport } from "../types/report";
import { asRefusal } from "./useServerAnswer";

export interface IncomeExpenseState {
  report: IncomeExpenseReport | null;
  /** The server's sentence when the report could not be read, else "". */
  error: string;
}

/** The client's all-time income-and-expense report, read once per client. */
export function useIncomeExpense(clientId: number): IncomeExpenseState {
  const [state, setState] = useState<IncomeExpenseState>({ report: null, error: "" });

  useEffect(() => {
    let cancelled = false;
    getIncomeExpense(clientId)
      .then((report) => {
        if (!cancelled) setState({ report, error: "" });
      })
      .catch((err: unknown) => {
        if (!cancelled) setState({ report: null, error: asRefusal(err).message });
      });
    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return state;
}
